import React from 'react';

type PV1Props = {
    text?: string | React.JSX.Element | Function,
    classes?: string[],
}

const PV1 = (props: PV1Props) => {

    let classes = ['p-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    return (
        <p 
            className={classes.join(' ')}
            >
            {typeof props.text === 'function' ? props.text() : props.text}
        </p>
    );

}

export default PV1;